<ng-container *ngIf="isURKidsCardSubscribed">
  <h2 class="rs-tit3">{{ 'common.settings' | translate }}</h2>
  <p>{{ 'kidsCard.noSettingsAvailableContent' | translate }}</p>
</ng-container>
<ng-container *ngIf="!isURKidsCardSubscribed">
<mprd-available-settings-skeleton
  *ngIf="!availableSettingsLoaded && !hasError"
></mprd-available-settings-skeleton>
<span *ngIf="availableSettingsLoaded || hasError">
  <h2 class="rs-tit3">{{ 'common.settings' | translate }}</h2>
  <px-alert
    [alerts]="[
      {
        type: 'error',
        title: 'mobile.settings.error.title' | translate,
        description: 'mobile.settings.error.message' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]"
    *ngIf="!availableSettingsLoaded && hasError"
  ></px-alert>
  <px-alert [alertKey]="getAlertKey()"></px-alert>
  <ng-container *ngIf="availableSettingsLoaded">
    <div class="panel rs-bg-grey1 clearfix" *ngFor="let category of categories">
      <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
        {{ category.name }}
      </h3>
      <mprd-setting
        *ngFor="let setting of selectedProduct.settings | filterByOptionCategory: category.id"
        [setting]="setting"
        [product]="selectedProduct"
      ></mprd-setting>
      <mprd-setting
        *ngFor="
          let setting of selectedProduct.configurableSettings | filterByOptionCategory: category.id
        "
        [setting]="setting"
        [product]="selectedProduct"
      ></mprd-setting>
    </div>
  </ng-container>
</span>
</ng-container>
